var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let ClusteringTraits = (_dec = primitiveTrait({
  name: "Enabled",
  description: "True to enable clustering. False by default",
  type: "boolean"
}), _dec2 = primitiveTrait({
  name: "pixelRange",
  description: "The pixel range to extend the screen space bounding box",
  type: "number"
}), _dec3 = primitiveTrait({
  name: "minimumClusterSize",
  description: "The minimum number of screen space objects that can be clustered",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "pinSize",
  description: "The size of the pin, in pixels",
  type: "number"
}), _dec5 = primitiveTrait({
  name: "pinBackgroundColor",
  type: "string",
  description: "The color of the pin"
}), _class = class ClusteringTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "enabled", _descriptor, this);
    _initializerDefineProperty(this, "pixelRange", _descriptor2, this);
    _initializerDefineProperty(this, "minimumClusterSize", _descriptor3, this);
    _initializerDefineProperty(this, "pinSize", _descriptor4, this);
    _initializerDefineProperty(this, "pinBackgroundColor", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pixelRange", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 35;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "minimumClusterSize", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 5;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pinSize", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 60;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pinBackgroundColor", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "gray";
  }
}), _class);
export { ClusteringTraits as default };